export const routes = (prefix = `outpatient`) => [
    {
        path: `/${prefix}/admission-note/print/:patientID/:visitNO`,
        name: `${prefix}.admission-note.print`,
        component: () => import('./AdmissionNote.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.admission-note.print`,
                PageDescription: "Outpatient: Admission note print",
            },
            print: true,
        },
    },
];
